"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prependMessageToError = exports.cloneError = exports.ignoreIfThrows = exports.catchIfThrows = void 0;
var tslib_1 = require("tslib");
exports.catchIfThrows = function (fn, errorHandler) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            var result = fn.apply(void 0, tslib_1.__spread(args));
            // if passed "fn" is async, in order to catch a rejection we'd need to await for it
            // using "await fn(...args)" would be wrong because sync function will start behaving as if they were async
            // thus we keep the execution sync unless result is "thenable"
            if ((result === null || result === void 0 ? void 0 : result.then) && result.catch) {
                return result.catch(function (error) { return errorHandler.apply(void 0, tslib_1.__spread([error], args)); });
            }
            return result;
        }
        catch (error) {
            errorHandler.apply(void 0, tslib_1.__spread([error], args));
        }
    };
};
exports.ignoreIfThrows = function (fn) {
    return exports.catchIfThrows(fn, function () { return null; });
};
exports.cloneError = function (originalError) {
    var e_1, _a;
    // @ts-ignore
    var error = new originalError.constructor();
    var propsToCopy = [
        'message',
        'stack',
        'name',
        'filename',
        'lineNumber',
        'columnNumber',
    ];
    try {
        for (var propsToCopy_1 = tslib_1.__values(propsToCopy), propsToCopy_1_1 = propsToCopy_1.next(); !propsToCopy_1_1.done; propsToCopy_1_1 = propsToCopy_1.next()) {
            var prop = propsToCopy_1_1.value;
            if (originalError[prop]) {
                error[prop] = originalError[prop];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (propsToCopy_1_1 && !propsToCopy_1_1.done && (_a = propsToCopy_1.return)) _a.call(propsToCopy_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return error;
};
exports.prependMessageToError = function (error, message) {
    var errorClone = exports.cloneError(error);
    errorClone.message = message + " " + errorClone.message;
    return errorClone;
};
//# sourceMappingURL=errorHandling.js.map